import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';
import Vuetify from 'vuetify';
import Element from 'element-ui'
import Notifications from 'vue-notification'
import VueSweetalert2 from 'vue-sweetalert2';
import moment from 'moment';
import Vuelidate from 'vuelidate'

Vue.prototype.$moment = moment

Vue.use(Vuetify, {
    theme: {
        primary: '#fff',
        secondary: '#304156',
        tree: '#01579b',
        primarytext: '#bfcbd9'
    }
})

Vue.use(Vuelidate)
Vue.use(VueResource);
Vue.use(Element);
Vue.use(Notifications);
const SweetalertOptions = {
  confirmButtonClass: 'v-btn secondary v-btn__content primarytext--text',
  cancelButtonClass: 'v-btn v-btn--flat error--text v-btn__content',
  buttonsStyling: false,
}
Vue.use(VueSweetalert2, SweetalertOptions);

//Vue.http.options.emulateJSON = true;
//Vue.http.options.emulateHTTP = true;
Vue.config.productionTip = false

/* eslint-disable no-new  */
new Vue({
    el: '#root',
    components: {App}
}) 


// WEBPACK FOOTER //
// ./template/accueil/js/main.js